import { MouseEvent, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useColorScheme } from '@mui/material/styles';
import { Box, Menu, MenuItem, Tooltip } from '@mui/material';
import DarkModeIcon from '@mui/icons-material/DarkModeRounded';
import LightModeIcon from '@mui/icons-material/LightModeRounded';
import IconButton, { IconButtonOwnProps } from '@mui/material/IconButton';

const ColorModeIconDropdown = (props: IconButtonOwnProps) => {
  // other hooks
  const { mode, systemMode, setMode } = useColorScheme();

  // useState hooks
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  // dynamic variables
  const open = Boolean(anchorEl);

  const resolvedMode = (systemMode || mode) as 'light' | 'dark';

  const icon = {
    light: <LightModeIcon />,
    dark: <DarkModeIcon />,
  }[resolvedMode];

  // sync helper functions
  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMode = (targetMode: 'system' | 'light' | 'dark') => () => {
    setMode(targetMode);
    handleClose();
  };

  if (!mode) {
    return (
      <Box
        data-screenshot="toggle-mode"
        sx={(theme) => ({
          verticalAlign: 'bottom',
          display: 'inline-flex',
          width: '2.25rem',
          height: '2.25rem',
          borderRadius: theme.shape.borderRadius,
          border: '1px solid',
          borderColor: theme.palette.divider,
        })}
      />
    );
  }

  return (
    <>
      <Tooltip title={<FormattedMessage id="theme.selectTheme" defaultMessage="Tema Seçiniz" />}>
        <IconButton
          data-screenshot="toggle-mode"
          onClick={handleClick}
          disableRipple
          size="small"
          aria-controls={open ? 'color-scheme-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          {...props}>
          {icon}
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            variant: 'outlined',
            elevation: 0,
            sx: {
              my: '4px',
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
        {/* <MenuItem selected={mode === 'system'} onClick={handleMode('system')}>
          System
        </MenuItem> */}
        <MenuItem selected={mode === 'light'} onClick={handleMode('light')}>
          Light
        </MenuItem>
        <MenuItem selected={mode === 'dark'} onClick={handleMode('dark')}>
          Dark
        </MenuItem>
      </Menu>
    </>
  );
};

export default ColorModeIconDropdown;
